$(function() {
	let checker;
	let padding = 20;

	$('.js-news-detail-side-link').click(function (e) {
		e.preventDefault();
		let id = $(this).attr('href');
		let top = $(id).offset().top;
		let headerHeight = $('.js-header').outerHeight();

		checker = 0;

		$('.js-news-detail-side-link').removeClass('news-detail__side-link_active');
		$(this).addClass('news-detail__side-link_active');

		$('html').animate({
			scrollTop: top - (headerHeight + padding)
		}, 1000);

		setTimeout(() => {
			checker = 1;
		}, 1000);
	});

	$(window).scroll(function () {
		let $anchor = $('.js-anchor');
		let scroll = $(window).scrollTop();
		let headerHeight = $('.js-header').outerHeight();

		$anchor.each(function (i, el) {
			let top = $(el).offset().top - headerHeight;
			let bottom = top + $(el).outerHeight();
			let id = $(el).attr('id');
			if (scroll > top && scroll < bottom && checker != 0) {
				$('.js-news-detail-side-link').removeClass('news-detail__side-link_active');
				$('.js-news-detail-side-link[href="#' + id + '"]').addClass('news-detail__side-link_active');
			}
		})
	});
})